/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      _this.element = $( '.programs-grid' );
      const urlPageParamIndex = window.location.pathname.indexOf( 'page' );
      const baseURL = urlPageParamIndex !== -1 ? window.location.pathname.substring( 0, urlPageParamIndex ) : window.location.pathname;

      $( '.images-area-slider.splide' ).each( function( index, slide ) {
        const splide = new Splide( slide, {
          type: 'slide',
          perPage: 1,
          perMove: 1,
          gap: '1rem',
          pagination: true,
          drag: false,
          arrows: false,
          live: true,
        } );

        splide.on( 'overflow', function( isOverflow ) {
          splide.options = {
            pagination: isOverflow,
          };
        } );

        splide.mount();
      } );

      if ( _this.element ) {
        $( document ).on( 'submit', '.js-programs-filter-form', function( event ) {
          event.preventDefault();
          const formData = new FormData( this );
          let formParams = `${ baseURL }`;
          let isFirst = true;
          for ( const [key, value] of formData.entries() ) {
            if ( value !== 'all' ) {
              formParams = isFirst ? `${formParams}?${key}=${value}` : `${formParams}&${key}=${value}`;
            }
            isFirst = false;
          }
          window.location = formParams;
          return false;
        } );
      }
    },
    finalize: function() {
    },
  };
  app.registerComponent( 'program', COMPONENT );
} )( app );
